import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiServerService } from './services/api-server.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FuseCardModule } from '../../@fuse/components/card/card.module';
import { FuseAlertModule } from '../../@fuse/components/alert';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { NgxMaskModule } from 'ngx-mask';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { SmmofCardComponent } from './components/card/card.component';
import { MatTableModule } from '@angular/material/table';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { DeclensionPipe } from './pipes/declension.pipe';
import { FlyingIconService } from './services/flying-icon.service';
import { TruncatePipe } from './pipes/truncate.pipe';
import { LogoLoaderComponent } from './components/logo-loader/logo-loader.component';
import { FileUploadService } from './services/file-upload.service';
import { TemporaryStorageService } from './services/temporary-storage.service';
import { FileSizePipe } from './pipes/file-size.pipe';
import { OrganizationComponent } from './components/organization/organization.component';
import { PublicationPreviewComponent } from './components/publication-preview/publication-preview.component';
import { PlatformInfoComponent } from './components/platform-info/platform-info.component';
import { SocialLinksComponent } from './components/social-links/social-links.component';
import { ScriptLoaderService } from './services/script-loader.service';
import {
  PublicationModalPreviewComponent
} from './components/publication-modal-preview/publication-modal-preview.component';
import {
  PublicationPreviewSmallComponent
} from './components/publication-preview-small/publication-preview-small.component';
import { DashCurrencyPipe } from './pipes/dash-currency.pipe';
import { TelegramTypeHumanPipe } from './pipes/telegram-type.pipe';
import { OrganizationCreateDialogComponent } from './components/organization/organization-create-dialog.component';
import { MyPlatformSelectComponent } from './components/my-platform-select/my-platform-select.component';


@NgModule({
  declarations: [
    DateRangeFilterComponent,
    SmmofCardComponent,
    StripHtmlPipe,
    DeclensionPipe,
    TruncatePipe,
    FileSizePipe,
    DashCurrencyPipe,
    TelegramTypeHumanPipe,
    LogoLoaderComponent,
    OrganizationComponent,
    OrganizationCreateDialogComponent,
    MyPlatformSelectComponent,
    PublicationPreviewComponent,
    PublicationPreviewSmallComponent,
    PublicationModalPreviewComponent,
    PlatformInfoComponent,
    SocialLinksComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FuseCardModule,
    FuseAlertModule,
    NgxMaskModule.forRoot(),
    MatSnackBarModule,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatDividerModule,
    MatSidenavModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSortModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatTableModule,
    MatButtonModule,
    MatButtonToggleModule
  ],
  exports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FuseCardModule,
    FuseAlertModule,
    NgxMaskModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatDividerModule,
    MatSidenavModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSortModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    DateRangeFilterComponent,
    SmmofCardComponent,
    StripHtmlPipe,
    DeclensionPipe,
    TruncatePipe,
    FileSizePipe,
    DashCurrencyPipe,
    TelegramTypeHumanPipe,
    LogoLoaderComponent,
    OrganizationComponent,
    OrganizationCreateDialogComponent,
    MyPlatformSelectComponent,
    PublicationPreviewComponent,
    PublicationPreviewSmallComponent,
    PublicationModalPreviewComponent,
    PlatformInfoComponent,
    SocialLinksComponent
  ],
  providers: [
    ApiServerService,
    FileUploadService,
    TemporaryStorageService,
    FlyingIconService,
    ScriptLoaderService,
    CurrencyPipe,
    {
      provide: MatPaginatorIntl,
      useValue: getRusPaginatorIntl(),
    },
  ],
})
export class SharedModule {}

export function getRusPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Показывать на странице:';
  paginatorIntl.nextPageLabel = 'Следующая страница';
  paginatorIntl.previousPageLabel = 'Предыдущая страница';

  return paginatorIntl;
}
